<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17.5 17.5">
    <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M12.3215339 8.7855339H5.2504661"/>
    <path d="M8.75 16.75a8 8 0 1 0-8-8 8 8 0 0 0 8 8Z" fill="none" stroke="currentColor" stroke-width="1.5"/>
  </svg>
</template>
